module.exports = __webpack_public_path__ + "img/customer_design_2@2x.769664b.jpg";